/* eslint-disable */

function safeParseJSON(jsonStr, defaultValue = null) {
  if (typeof jsonStr !== "string" || !jsonStr.trim()) {
    return defaultValue;
  }
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return defaultValue;
  }
}

// 定义一个混入对象
const myMixin = {
  data() {
    return {
      logic1: "",
    };
  },
  computed: {
    sceneData() {
      // 保存的部门
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].task[this.stepIndex - 1].SceneList;
    },
  },
  methods: {
    logic() {
      console.log(this.$parent.assemblyList);
      let logic;
      this.$Modal.confirm({
        render: (h) => {
          return h("div", {}, [
            h("h4", "跳转逻辑"),
            h(
              "div",
              {
                style: {
                  borderTop: "1px solid #dddddd",
                  height: "1px",
                  marginTop: "5px",
                },
              },
              ""
            ),
            h(
              "p",
              {
                style: {
                  padding: "15px",
                  fontSize: "14px",
                },
              },
              "该场景与(下拉框可以选择该任务下的场景)并列"
            ),
            h(
              "Select",
              {
                value: this.form.logic,
                on: {
                  "on-change": (value) => {
                    logic = value;
                    console.log(this.form.logic);
                  },
                },
              },
              [
                this.$parent.assemblyList.map((res, index) => {
                  return h(
                    "Option",
                    {
                      props: {
                        value: index,
                        labelL: res.fun_office,
                      },
                    },
                    res.fun_office
                  );
                }),
              ]
            ),
          ]);
        },
        onCancel: () => {
          this.form.logic = "";
        },
        onOk: () => {
          this.form.logic = logic;
        },
      });
    },
    ObtainSubject(data) {
      this.assemblyList = [];
      //   debugger;
      let i;
      let obj;
      console.log(data, "执行");
      data.forEach((element, index) => {
        if (data[index + 1] && +data[index + 1].pageNumber > +element.pageNumber) {
          // 有分割线的情况
          console.log("🚀 ~ data.forEach ~ element.type:", element.type);
          switch (element.type) {
            case "SINGLECHOICE":
              i = "Single";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: +element.answer,
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "MULTIPLECHOICEA":
              i = "MultipleA";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: safeParseJSON(element.answer, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "MULTIPLECHOICEB":
              i = "MultipleB";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: safeParseJSON(element.answer, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "GAPFILLING":
              i = "Fillblank";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                answer: "",
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                scoringKeywords: safeParseJSON(element.scoringKeywords, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "ESSAYQUESTION":
              i = "EasyQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                scoringKeywords: safeParseJSON(element.scoringKeywords, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "FILLBLANKS":
              i = "MultipeChoice";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                analysis: element.analysis,
                score: element.score,
                answer: safeParseJSON(element.answer, {}),
              };
              break;
            case "TABLEQUESTION":
              i = "TableQuestion";
              console.log("进入有分割线assemblyList TABLEQUESTION");
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                // score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "ligatureQuestion":
              i = "ligatureQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "determineQuestion":
              i = "determineQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                score: element.score,
                extend: JSON.parse(element.extend) || "",
              };
              break;
            case "MATERIALANALYSISPROBLEM":
              i = "Material";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                analysis: element.analysis,
                score: element.score,
                answer: JSON.parse(element.answer),
                scoringKeywords: safeParseJSON(element.scoringKeywords, {}),
              };
              break;
            case "CASEGUIDE":
              i = "CaseGuide";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                title: element.title,
              };
              break;
            case "SINGLETEXT":
              i = "CaseSingleText";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                title: element.title,
              };
              break;
            case "TEXTAXIS":
              i = "CaseAxis";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "DIALOGUE":
              i = "CaseDialogue";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "ASKANDANSWER":
              i = "CaseAskAndAnswer";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "INFOBASE":
              i = "CaseInfoBase";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "DEPARTMENT":
              i = "CaseDepartment";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "CASEUPLOAD":
              i = "CaseUpload";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
              };
              break;
            case "VIDEOFILE":
              i = "CaseVideo";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                image: element.image,
                answer: element.answer,
              };
              break;
            case "PICTURETEXT":
              i = "CasePhotoText";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
                answer: element.answer,
                image: element.image,
              };
              break;
            case "HEADLINE":
              i = "CaseTitle";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
              };
              break;
            case "SMALLTITLE":
              i = "smallCaseTitle";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
              };
              break;
            default:
              break;
          }
          if (element.BMWJ || element.ZLK) {
            if (element.BMWJ?.length > 0) {
              this.assemblyList.push({
                name: "CaseDepartment",
                data: {
                  DeptData: element.BMWJ,
                },
              });
            }
            if (element.ZLK?.length > 0) {
              this.assemblyList.push({
                name: "CaseInfoBase",
                data: {
                  infoData: element.ZLK,
                },
              });
            }
          } else {
            console.log("进入没有BMW");
            this.assemblyList.push({
              name: i,
              data: obj,
            });
          }
          this.assemblyList.push({
            name: "Divider",
          });
          // if (i?.toLowerCase() == element.type?.toLowerCase()) {
          //   console.log();
          // }
          console.log("有分割", i, obj);
        } else {
          // 没有分割线的情况
          console.log(element.type, "element.typeelement.type");
          switch (element.type) {
            case "SINGLECHOICE":
              i = "Single";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: +element.answer,
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "MULTIPLECHOICEA":
              i = "MultipleA";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: safeParseJSON(element.answer, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "MULTIPLECHOICEB":
              i = "MultipleB";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                showTips: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                answer: safeParseJSON(element.answer, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "GAPFILLING":
              i = "Fillblank";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                answer: "",
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                scoringKeywords: safeParseJSON(element.scoringKeywords, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "ESSAYQUESTION":
              i = "EasyQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                scoringKeywords: safeParseJSON(element.scoringKeywords, {}),
                analysis: element.analysis,
                score: element.score,
              };
              break;
            case "FILLBLANKS":
              i = "MultipeChoice";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                analysis: element.analysis,
                score: element.score,
                answer: safeParseJSON(element.answer, {}),
              };
              break;
            case "TABLEQUESTION":
              i = "TableQuestion";
              console.log("进入无割线assemblyList TABLEQUESTION");
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                // score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "ligatureQuestion":
              i = "ligatureQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "determineQuestion":
              i = "determineQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                score: element.score,
                extend: JSON.parse(element.extend) || "",
              };
              break;
            case "MATERIALANALYSISPROBLEM":
              i = "Material";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                analysis: element.analysis,
                score: element.score,
                answer: safeParseJSON(element.answer,{}),
                scoringKeywords: safeParseJSON(element.scoringKeywords,{}),
              };
              break;
            case "CASEGUIDE":
              i = "CaseGuide";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                title: element.title,
              };
              break;
            case "SINGLETEXT":
              i = "CaseSingleText";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                title: element.title,
              };
              break;
            case "TEXTAXIS":
              i = "CaseAxis";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas,{}),
              };
              break;
            case "DIALOGUE":
              i = "CaseDialogue";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas,{}),
              };
              break;
            case "ASKANDANSWER":
              i = "CaseAskAndAnswer";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas,{}),
              };
              break;
            case "INFOBASE":
              i = "CaseInfoBase";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas,{}),
              };
              break;
            case "DEPARTMENT":
              i = "CaseDepartment";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas,{}),
              };
              break;
            case "CASEUPLOAD":
              i = "CaseUpload";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
              };
              break;
            case "VIDEOFILE":
              i = "CaseVideo";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                image: element.image,
                answer: element.answer,
              };
              break;
            case "PICTURETEXT":
              i = "CasePhotoText";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
                answer: element.answer,
                image: element.image,
              };
              break;
            case "HEADLINE":
              i = "CaseTitle";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
              };
              break;
            case "SMALLTITLE":
              i = "smallCaseTitle";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
              };
              break;
            default:
              break;
          }
          if (element.BMWJ || element.ZLK) {
            if (element.BMWJ?.length > 0) {
              this.assemblyList.push({
                name: "CaseDepartment",
                data: {
                  DeptData: element.BMWJ,
                },
              });
            }
            if (element.ZLK?.length > 0) {
              this.assemblyList.push({
                name: "CaseInfoBase",
                data: {
                  infoData: element.ZLK,
                },
              });
            }
          } else {
            console.log("进入没有BMW2");
            this.assemblyList.push({
              name: i,
              data: obj,
            });
          }
          // if (element.BMWJ && element.BMWJ.length > 0) {
          //   this.assemblyList.push({
          //     name: "CaseDepartment",
          //     data: {
          //       DeptData: element.BMWJ
          //     }
          //   });
          // } else if (element.ZLK && element.ZLK.length > 0) {
          //   this.assemblyList.push({
          //     name: "CaseInfoBase",
          //     data: {
          //       infoData: element.ZLK
          //     }
          //   });
          // } else {
          //   this.assemblyList.push({
          //     name: i,
          //     data: obj
          //   });
          // }
          // if (i?.toLowerCase() == element.type?.toLowerCase()) {
          //   console.log();
          // }
          console.log(obj, i);
        }
        console.log("无分割", i, obj);
      });
      console.log(this.assemblyList, "assemblyListassemblyListassemblyList");
    },
    addSubject() {
      let i;
      const data =
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .task[this.$parent.stepIndex].SceneList[this.eachIndex];
      if (data && data.sceneControl) {
        // 先判断题目有没有

        data.sceneControl.forEach((item) => {
          let obj = {};
          console.log(item.type, "item.type有的");
          switch (item.type) {
            case "SINGLECHOICE":
              // 单选题
              i = "Single";
              obj = {
                id: item.id,
                tsId: item.tsId,
                stem: item.title,
                tip: item.hint,
                showTips: false,
                metas: safeParseJSON(item.stem, {}),
                answer: +item.answer,
                analysis: item.analysis,
                score: item.score,
              };
              break;
            case "MULTIPLECHOICEA":
              // 多选题1
              i = "MultipleA";
              obj = {
                id: item.id,
                tsId: item.tsId,
                stem: item.stem,
                tip: item.hint,
                options: safeParseJSON(item.stem, {}),
                answer: safeParseJSON(item.answer, {}),
                analysis: item.analysis,
                score: item.score,
              };
              break;
            case "MULTIPLECHOICEB":
              // 多选题2
              i = "MultipleB";
              obj = {
                id: item.id,
                tsId: item.tsId,

                title: item.title,
                tip: item.hint,
                options: safeParseJSON(item.stem, {}),
                answer: safeParseJSON(item.answer, {}),
                analysis: item.analysis,
                score: item.score,
              };
              break;
            case "GAPFILLING":
              // 填空题
              i = "Fillblank";
              obj = {
                id: item.id,
                tsId: item.tsId,

                title: item.title,
                tips: item.hint,
                type: safeParseJSON(item.answer, {}),
                single: item.isShow,
                explain: item.analysis,
                type2: safeParseJSON(item.scoringKeywords, {}),
                score: item.score,
              };
              break;
            case "ESSAYQUESTION":
              // 问答题
              i = "EasyQuestion";
              obj = {
                id: item.id,
                tsId: item.tsId,

                stem: item.title,
                tips: item.hint,
                answer: item.answer,
                show: item.isShow,
                analysis: item.analysis,
                scoringKeywords: safeParseJSON(item.scoringKeywords, {}),
                score: item.score,
              };
              break;
            case "FILLBLANKS":
              // 选择填空题
              i = "MultipeChoice";
              console.log(item);
              obj = {
                id: item.id,
                tsId: item.tsId,

                stem: item.title,
                tips: item.hint,
                metas: safeParseJSON(item.stem, {}),
                answer: item.answer,
                analysis: item.analysis,
                score: item.score,
              };
              console.log(obj);
              break;
            case "TABLEQUESTION":
              i = "TableQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                // score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "ligatureQuestion":
              i = "ligatureQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                // tips: element.hint,
                // isShow: element.isShow,
                metas: safeParseJSON(element.metas, {}),
                // analysis: element.analysis,
                score: element.score,
                // answer: JSON.parse(element.answer)
              };
              break;
            case "determineQuestion":
              i = "determineQuestion";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                tips: element.hint,
                metas: safeParseJSON(element.metas, {}),
                score: element.score,
                extend: JSON.parse(element.extend) || "",
              };
              break;
            case "MATERIALANALYSISPROBLEM":
              // 材料题
              i = "Material";
              //
              obj = {
                id: item.id,
                tsId: item.tsId,
                title: item.title,
                tip: item.hint,
                questionsList: safeParseJSON(item.stem, {}),
                score: item.score,
                scoringKeywords: safeParseJSON(item.scoringKeywords, {}),
                analysis: item.analysis,
              
                parseAnswer: safeParseJSON(item.answer, {}).parseAnswer,
                parseQuestion: safeParseJSON(item.answer, {}).AnalysisProblem,
              };
              break;
            case "DIALOGUE":
              // i = "初始对话";
              // obj = {
              //   id: item.id,
              //   tsId: item.tsId,
              //   content: JSON.parse(item.stem)
              // }
              this.talkList = safeParseJSON(item.stem, {});
              break;
            case "ASKANDANSWER":
              i = "CaseAskAndAnswer";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "INFOBASE":
              i = "CaseInfoBase";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "DEPARTMENT":
              i = "CaseDepartment";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                metas: safeParseJSON(element.metas, {}),
              };
              break;
            case "CASEUPLOAD":
              i = "CaseUpload";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
              };
              break;
            case "CASEGUIDE":
              i = "CaseGuide";
              obj = {
                id: element.id,
                tsId: element.tsId,
                stem: element.stem,
                title: element.title,
                answer: "",
                analysis: "",
              };
              break;
            case "HEADLINE":
              i = "CaseTitle";
              obj = {
                id: element.id,
                tsId: element.tsId,
                title: element.title,
                stem: element.stem,
              };
              break;
            default:
              break;
          }
          console.log("直接输入", this.assemblyList);
          this.assemblyList.push({
            name: i,
            data: obj,
          });
        });
      }
    },
    AddToControl(res) {
      // 新建题目
      const scene = this.$refs[`task${this.stepIndex}`][0].$refs; // 定义大厅数据
      const DATA = [];
      for (let i in scene) {
        DATA.push(i);
      }
      DATA.forEach((element, index) => {
        let index2 = 1;
        let id;
        if (res.data.data[index]) {
          id = res.data.data[index].id;
        } else {
          id = this.sceneData[index2].id;
        }
        console.log(
          "🚀 ~ DATA.forEach ~ scene[element][0].assemblyList:",
          scene[element][0].assemblyList
        );

        for (const iterator of scene[element][0].assemblyList) {
          let form = new FormData();
          let pageNumber = 0;
          switch (iterator.name) {
            case "Single":
              // 单选题模块
              form.append("type", "SINGLECHOICE");
              form.append("stem", JSON.stringify(iterator.data.metas));
              form.append("answer", iterator.data.answer);
              form.append("isShow", false);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.answer);
              form.append("hint", iterator.data.tips ? iterator.data.tips : "");
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "MultipleA":
              // 多选题模块1
              form.append("type", "MULTIPLECHOICEA");
              form.append("stem", iterator.data.stem);
              form.append("answer", JSON.stringify(iterator.data.answer));
              form.append("isShow", false);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips ? iterator.data.tips : "");
              form.append("title", iterator.data.title);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "MultipleB":
              // 多选题模块2
              form.append("type", "MULTIPLECHOICEB");
              form.append("stem", JSON.stringify(iterator.data.options));
              form.append("answer", JSON.stringify(iterator.data.answer));
              form.append("isShow", false);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips ? iterator.data.tips : "");
              form.append("title", iterator.data.title);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "Fillblank":
              // 填空题模块
              form.append("type", "GAPFILLING");
              form.append("stem", "填空题状态下--这个字段废弃");
              form.append("answer", JSON.stringify(iterator.data.type));
              form.append("isShow", iterator.data.single);
              form.append("tsId", id);
              form.append("analysis", iterator.data.explain);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.title);
              form.append("scoringKeywords", JSON.stringify(iterator.data.type2));
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "EasyQuestion":
              // 问答题模块
              form.append("type", "ESSAYQUESTION");
              form.append("stem", "问答题状态下--这个字段废弃");
              form.append("answer", iterator.data.answer);
              form.append("isShow", iterator.data.show);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", JSON.stringify(iterator.data.scoringKeywords));
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "MultipeChoice":
              // 选择填空题模块
              form.append("type", "FILLBLANKS");
              form.append("stem", JSON.stringify(iterator.data.metas));
              form.append("answer", iterator.data.answer);
              form.append("isShow", iterator.data.isEditTips);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "TableQuestion":
              // 选择填空题模块
              form.append("type", "TABLEQUESTION");
              form.append("stem", JSON.stringify(iterator.data.metas));
              form.append("answer", iterator.data.answer);
              form.append("isShow", iterator.data.isEditTips);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "ligatureQuestion":
              // 选择填空题模块
              form.append("type", "ligatureQuestion");
              form.append("stem", JSON.stringify(iterator.data.metas));
              form.append("answer", iterator.data.answer);
              form.append("isShow", iterator.data.isEditTips);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "determineQuestion":
              // 改错题模块
              form.append("type", "determineQuestion");
              form.append("stem", JSON.stringify(iterator.data.metas));
              // form.append("answer", iterator.data.answer);
              form.append("isShow", iterator.data.isEditTips);
              form.append("tsId", id);
              // form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.stem);
              form.append("scoringKeywords", "");
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              form.append("extend", iterator.data.extend);
              break;
            case "Material":
              // 材料题模块
              let i = {
                AnalysisProblem: iterator.data.parseQuestion,
                parseAnswer: iterator.data.parseAnswer,
              };
              i = JSON.stringify(i);
              form.append("type", "MATERIALANALYSISPROBLEM");
              form.append("stem", JSON.stringify(iterator.data.questionsList));
              form.append("answer", i);
              form.append("isShow", false);
              form.append("tsId", id);
              form.append("analysis", iterator.data.analysis);
              form.append("score", iterator.data.score);
              form.append("hint", iterator.data.tip);
              form.append("title", iterator.data.title);
              form.append("scoringKeywords", JSON.stringify(iterator.data.scoringKeywords));
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "CASEGUIDE":
              // 案例引导
              form.append("type", "CaseGuide");
              // form.append("stem", "填空题状态下--这个字段废弃");
              form.append("answer", "");
              // form.append("isShow", iterator.data.single);
              form.append("tsId", id);
              form.append("stem", iterator.data.stem);
              // form.append("score", iterator.data.score);
              // form.append("hint", iterator.data.tips);
              form.append("title", iterator.data.title);
              // form.append(
              //   "scoringKeywords",
              //   JSON.stringify(iterator.data.type2)
              // );
              form.append("skip", "");
              form.append("pageNumber", pageNumber);
              break;
            case "INFOBASE":
              // 资料文件
              console.log("有的");
              // form.append("type", "CaseInfoBase");
              // // form.append("stem", "填空题状态下--这个字段废弃");
              // form.append("answer", "");
              // // form.append("isShow", iterator.data.single);
              // form.append("tsId", id);
              // form.append("stem", iterator.data.stem);
              // // form.append("score", iterator.data.score);
              // // form.append("hint", iterator.data.tips);
              // form.append("title", iterator.data.title);
              // // form.append(
              // //   "scoringKeywords",
              // //   JSON.stringify(iterator.data.type2)
              // // );
              // form.append("skip", "");
              // form.append("pageNumber", pageNumber);
              break;
            default:
              pageNumber += 1;
              break;
          }
          form.append("controlSequenceNumber", index2);
          index2 += 1;
          console.log(form, "form新建");
          this.$http.createOrUpdateControl(form).then((res) => {});
        }
      });
      this.$Spin.hide();
    },
    dragstart(name) {
      this.assemblyName = "";
      this.selectDepartment = name;
      switch (name) {
        case "单选题":
          this.assemblyName = "Single";
          break;
        case "多选题1":
          this.assemblyName = "MultipleA";
          break;
        case "多选题2":
          this.assemblyName = "MultipleB";
          break;
        case "填空题":
          this.assemblyName = "Fillblank";
          break;
        case "材料题":
          this.assemblyName = "Material";
          break;
        case "问答题":
          this.assemblyName = "EasyQuestion";
          break;
        case "矩阵选择题":
          this.assemblyName = "Matrix";
          break;
        case "案例引导语":
          this.assemblyName = "CaseGuide";
          break;
        case "消息通知":
          this.assemblyName = "CaseTitleText";
          break;
        case "文字——单文字":
          this.assemblyName = "CaseSingleText";
          break;
        case "文字——轴型":
          this.assemblyName = "CaseAxis";
          break;
        case "人物对话":
          this.assemblyName = "CaseDialogue";
          break;
        case "提问-回答":
          this.assemblyName = "CaseAskAndAnswer";
          break;
        case "资料库":
          this.assemblyName = "CaseInfoBase";
          break;
        case "部门文件":
          this.assemblyName = "CaseDepartment";
          break;
        case "附件":
          this.assemblyName = "CaseUpload";
          break;
        case "文字图片":
          this.assemblyName = "CasePhotoText";
          break;
        case "视频文件":
          this.assemblyName = "CaseVideo";
          break;
        case "标题":
          this.assemblyName = "CaseTitle";
          break;
        case "小标题":
          this.assemblyName = "smallCaseTitle";
          break;
        case "选择填空题":
          this.assemblyName = "MultipeChoice";
          break;
        case "表格题":
          this.assemblyName = "TableQuestion";
          break;
        case "连线题":
          this.assemblyName = "ligatureQuestion";
          break;
        case "改错题":
          this.assemblyName = "determineQuestion";
          break;
        case "分割线":
          this.assemblyName = "Divider";
          break;
        case "首页大厅":
          this.assemblyName = "HALLBACKGROUND";
          break;
        case "领导办公室":
          this.assemblyName = "LEADERSHIPOFFICE";
          break;
        case "我的办公室":
          this.assemblyName = "MYOFFICE";
          break;
        case "民意调查中心":
          this.assemblyName = "POLLINGCENTER";
          break;
        case "现场调研":
          this.assemblyName = "SURVEY";
          break;
        case "会议室":
          this.assemblyName = "METTING";
          break;
        case "部门1":
          this.assemblyName = "UnitA";
          break;
        case "部门2":
          this.assemblyName = "UnitB";
          break;
        case "部门3":
          this.assemblyName = "UnitC";
          break;
        case "部门4":
          this.assemblyName = "UnitD";
          break;
        case "部门5":
          this.assemblyName = "UnitE";
          break;
        case "部门6":
          this.assemblyName = "UnitF";
          break;
        case "部门7":
          this.assemblyName = "UnitG";
          break;
        case "部门8":
          this.assemblyName = "UnitH";
          break;
        case "部门9":
          this.assemblyName = "UnitI";
          break;
        case "部门10":
          this.assemblyName = "UnitJ";
          break;
        case "部门11":
          this.assemblyName = "UnitK";
          break;
        case "部门12":
          this.assemblyName = "UnitL";
          break;
        case "部门13":
          this.assemblyName = "UnitM";
          break;
        case "部门14":
          this.assemblyName = "UnitN";
          break;
        case "部门15":
          this.assemblyName = "UnitO";
          break;
        case "部门16":
          this.assemblyName = "UnitP";
          break;
        case "部门17":
          this.assemblyName = "UnitQ";
          break;
        // case "部门18":
        //   this.assemblyName = "UnitR";
        //   break;
        // case "部门19":
        //   this.assemblyName = "UnitS";
        //   break;
        // case "部门20":
        //   this.assemblyName = "UnitT";
        //   break;
        // case "部门21":
        //   this.assemblyName = "UnitU";
        //   break;
        // case "部门22":
        //   this.assemblyName = "UnitV";
        //   break;
        // case "部门23":
        //   this.assemblyName = "UnitW";
        //   break;
        // case "部门24":
        //   this.assemblyName = "UnitX";
        //   break;
        // case "部门25":
        //   this.assemblyName = "UnitY";
        //   break;
        // case "部门26":
        //   this.assemblyName = "UnitZ";
        //   break;
        default:
          this.$Message.error("暂无该组件");
          break;
      }
    },
  },
};
export default myMixin;
